import { ChecklistFolderList } from 'models/index.m';
import { RootState } from '../../store';

export const getChecklistFolderListIsFetching = (
  state: RootState,
): boolean | null => state?.checklistData?.isChecklistFolderFetching;

export const getChecklistFolderIsAdding = (state: RootState): boolean | null =>
  state?.checklistData?.isChecklistFolderAdding;

export const getChecklistFolderIsRemoving = (
  state: RootState,
): boolean | null => state?.checklistData?.isChecklistFolderRemoving;

export const getChecklistFolderIsUpdating = (
  state: RootState,
): boolean | null => state?.checklistData?.isChecklistFolderUpdateing;

export const getChecklistIsAdding = (state: RootState): boolean =>
  state?.checklistData?.isChecklistAdding;

export const getChecklistIsRemoving = (state: RootState): boolean | null =>
  state?.checklistData?.isChecklistRemoving;

export const getChecklistIsUpdating = (state: RootState): boolean =>
  state?.checklistData?.isChecklistUpdating;

export const getChecklistFolderListDataOnly = (
  state: RootState,
): ChecklistFolderList[] | null =>
  state?.checklistData?.checklistFolderData?.data;

export const getisChecklistFolderFetching = (
  state: RootState,
): ChecklistFolderList[] | null =>
  state?.checklistData?.isChecklistFolderFetching;

export const getChecklistItemIsUpdating = (state: RootState): boolean =>
  state?.checklistData?.isChecklistItemUpdateing;

export const getChecklistItemIsRemoving = (state: RootState): boolean | null =>
  state?.checklistData?.isChecklistItemRemoving;

export const getChecklistItemIsAdding = (state: RootState): boolean =>
  state?.checklistData?.isChecklistItemAdding;

export const getChecklistItemIsAddSuccess = (state: RootState): boolean =>
  state?.checklistData?.isChecklistItemAddSuccess;

export const getExistChecklistItemIsAddSuccess = (state: RootState): boolean =>
  state?.checklistData?.isExistChecklistItemAddSuccess;

export const getChecklistItemIsUpdateSuccess = (state: RootState): boolean =>
  state?.checklistData?.isChecklistItemUpdateSuccess;

export const getChecklistIsAddSuccess = (state: RootState): boolean =>
  state?.checklistData?.isChecklistAddSuccess;

export const getChecklistIsRemoveSuccess = (state: RootState): boolean =>
  state?.checklistData?.isChecklistRemoveSuccess;

export const getChecklistIsUpdateSuccess = (state: RootState): boolean =>
  state?.checklistData?.isChecklistUpdateSuccess;

export const getChecklistItemIsRemoveSuccess = (state: RootState): boolean =>
  state?.checklistData?.isChecklistItemRemoveSuccess;

export const getExistChecklistItemIsAdding = (state: RootState): boolean =>
  state?.checklistData?.isExistChecklistItemAdding;

export const getChecklistFolderSortOrderIsSuccess = (
  state: RootState,
): boolean => state?.checklistData?.isChecklistFolderSortOrderIsSuccess;
